import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { basketSelectors } from '@store/basket/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { DynamicPackagesConfigurationWizard } from './DynamicPackagesConfigurationWizard';
import {
  DynamicPackagesConfigurationWizardDispatchProps,
  DynamicPackagesConfigurationWizardStoreProps,
} from './DynamicPackagesConfigurationWizard.types';
import { createBasket, updateBasket } from '@store/basket/actions';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state): DynamicPackagesConfigurationWizardStoreProps => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  loggedGuest: guestSelectors.getGuest(state),
  basketGuests: basketSelectors.getBasketGuests(state),
  reservedSpaTimeSlots: basketSelectors.getReservedSpaTimeSlots(state),
});

const mapDispatchToProps = (dispatch): DynamicPackagesConfigurationWizardDispatchProps =>
  bindActionCreators(
    {
      createBasket,
      updateBasket,
    },
    dispatch
  );

export const DynamicPackagesConfigurationWizardConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicPackagesConfigurationWizard);
